module.exports = function anonymous(it
) {
var out='<option value="'+(it.value)+'">'+(it.label)+'</option>';return out;
}